/* lv-anim.js : couche d'animations lecteur-vitale.fr (accueil, fiches produit, catalogue). Validée en maquette accueil-v5. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = matchMedia('(hover: hover)').matches;
  var $ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  if (reduce) return;

  function split(node, ctr) {
    Array.prototype.slice.call(node.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        if (!n.nodeValue.trim()) return;
        var f = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { f.appendChild(document.createTextNode(p)); return; }
          var w = document.createElement('span'); w.className = 'lva-w';
          var b = document.createElement('b'); b.textContent = p; b.style.setProperty('--i', ctr.i++);
          w.appendChild(b); f.appendChild(w);
        });
        n.parentNode.replaceChild(f, n);
      } else if (n.nodeType === 1 && n.tagName !== 'BR' && n.tagName.toLowerCase() !== 'svg' && !n.classList.contains('flag')) split(n, ctr);
    });
  }
  var heads = $('.lva4 .h2, .lva4 .end-t, .lva4 .mnt-t, .lv-h2, .lvP h2').filter(function (h) { return !h.closest('.hero2'); });
  var wio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lva-go'); wio.unobserve(e.target); } }); }, { threshold: .35 });
  heads.forEach(function (h) { split(h, { i: 0 }); wio.observe(h); });

  var map = [
    ['.lvc', 'lva-card'], ['.lvp-ac', 'lva-flip'], ['.lvp-adv-grid > *', 'lva-flip'], ['.lvp-cc', 'lva-card'],
    ['.lvp-img4', 'lva-zoom'], ['.lvp-faq details', ''], ['.lvp-mini > *', 'lva-left'], ['.lvp-tabs-sec', ''], ['.lvp-fr', 'lva-zoom']
  ];
  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target; t.classList.remove('lva-pre'); t.classList.add('lva-in', 'lva-seen'); rio.unobserve(t);
    });
  }, { threshold: .12 });
  function arm(root) {
    map.forEach(function (m) {
      $(m[0], root).forEach(function (el, i) {
        if (el.dataset.lvaArmed) return;
        el.dataset.lvaArmed = '1';
        if (el.getBoundingClientRect().top < innerHeight * .9 && el.closest('.lvp-info, .lvp-gal')) return;
        el.style.setProperty('--d', ((i % 4) * 110) + 'ms');
        if (m[1]) el.classList.add(m[1]);
        el.classList.add('lva-pre'); rio.observe(el);
      });
    });
  }
  arm(document);
  var grid = document.getElementById('grid');
  if (grid) {
    var stag = function () { $('.card', grid).forEach(function (c, i) { c.style.transitionDelay = ((i % 4) * 110) + 'ms'; }); };
    stag(); new MutationObserver(stag).observe(grid, { childList: true });
    grid.addEventListener('mousemove', function (e) {
      var c = e.target.closest('.card'); if (!c) return; var r = c.getBoundingClientRect();
      c.style.setProperty('--cx', (e.clientX - r.left) + 'px'); c.style.setProperty('--cy', (e.clientY - r.top) + 'px');
    });
  }
  document.addEventListener('mousemove', function (e) {
    var c = e.target.closest && e.target.closest('.lvc'); if (!c) return; var r = c.getBoundingClientRect();
    c.style.setProperty('--cx', (e.clientX - r.left) + 'px'); c.style.setProperty('--cy', (e.clientY - r.top) + 'px');
  });

  var bar = document.createElement('div'); bar.className = 'lva-pbar'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar);

  var hero = document.querySelector('.lva4 .hero2');
  if (hero) {
    for (var i = 0; i < 32; i++) {
      var s = document.createElement('span'); s.className = 'spk';
      s.style.left = (3 + Math.random() * 94) + '%'; s.style.animationDuration = (5 + Math.random() * 6) + 's'; s.style.animationDelay = (-Math.random() * 10) + 's';
      s.style.setProperty('--dx', ((Math.random() - .5) * 200) + 'px'); hero.appendChild(s);
    }
    if (hover) {
      var hin = hero.querySelector('.h-in'), chips = $('.chipf', hero);
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        if (hin) hin.style.transform = 'translate(' + (x * -36).toFixed(1) + 'px,' + (y * -24).toFixed(1) + 'px)';
        chips.forEach(function (c, i) { var k = (i + 1) * 34; c.style.translate = (x * k).toFixed(1) + 'px ' + (y * k).toFixed(1) + 'px'; });
      });
      hero.addEventListener('mouseleave', function () { if (hin) hin.style.transform = ''; chips.forEach(function (c) { c.style.translate = ''; }); });
    }
  }

  if (hover) $('.lvP .lvp-main').forEach(function (m) {
    m.addEventListener('mousemove', function (e) {
      var r = m.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5, img = m.querySelector('img');
      m.style.setProperty('--cx', (e.clientX - r.left) + 'px'); m.style.setProperty('--cy', (e.clientY - r.top) + 'px');
      if (img) img.style.translate = (x * -22).toFixed(1) + 'px ' + (y * -22).toFixed(1) + 'px';
    });
    m.addEventListener('mouseleave', function () { var img = m.querySelector('img'); if (img) img.style.translate = ''; });
  });

  if (hover) $('.btn:not(.hc-tel), .lv-btn, .lva4 .hcontact a:not(.hc-tel)').forEach(function (b) {
    b.classList.add('lva-mag');
    b.addEventListener('mousemove', function (e) { var r = b.getBoundingClientRect(); b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * .35 - 3).toFixed(1) + 'px)'; });
    b.addEventListener('mouseleave', function () { b.style.transform = ''; });
  });

  var why = document.querySelector('.lva4 .why'), glows = $('.lva4 .h-glow'), brands = document.querySelector('.lva4 .brands-in');
  var last = scrollY, vel = 0, tick = false;
  function onS() {
    if (tick) return; tick = true;
    requestAnimationFrame(function () {
      var y = scrollY, h = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? y / h : 0).toFixed(4) + ')';
      vel = y - last; last = y;
      glows.forEach(function (g, i) { g.style.translate = '0 ' + (y * (i ? -.12 : .18)).toFixed(0) + 'px'; });
      if (why) { var r = why.getBoundingClientRect(); why.style.setProperty('--py', (-r.top * .25).toFixed(0) + 'px'); }
      if (brands) brands.style.transform = 'skewX(' + Math.max(-8, Math.min(8, -vel * .25)).toFixed(2) + 'deg)';
      tick = false;
    });
  }
  addEventListener('scroll', onS, { passive: true }); onS();
  if (brands) setInterval(function () { vel *= .6; if (Math.abs(vel) < .5) brands.style.transform = ''; }, 120);
})();
